<app-page title="License Renewals">
    <!-- Action Buttons -->
    <div actionButtons>
        <p-button
            size="small"
            (onClick)="resetTableState()"
            severity="secondary"
            pTooltip="Reset filters"
            tooltipPosition="top"
            [text]="true"
            data-testid="reset-all-filters">
            <fa-icon [icon]="['fas', 'rotate-left']" size="lg" transform="rotate-90"></fa-icon>
        </p-button>
        @if (canCreateReview()) {
            <p-button
                label="New"
                icon="pi pi-plus"
                size="small"
                class="ml-3"
                (onClick)="openCreateDialog()"
                [disabled]="licenseStore.activeReviewLoading()"
                data-testid="create-review-button">
            </p-button>
        }
    </div>

    <!-- Reviews Grid -->
    <ag-grid-angular
        class="ag-theme-quartz ag-grid-table"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        (columnVisible)="adjustColumnSizes()"
        (toolPanelVisibleChanged)="adjustColumnSizes()"
        (firstDataRendered)="adjustColumnSizes()">
    </ag-grid-angular>
</app-page>

<!-- Start Renewal Process Dialog -->
<p-dialog
    header="Start License Renewal Process"
    [(visible)]="showCreateDialog"
    [modal]="true"
    [draggable]="false"
    [style]="{width: '600px'}"
    [closable]="true"
    [closeOnEscape]="true"
    (onHide)="closeCreateDialog()">

    <form [formGroup]="createReviewForm" class="p-fluid">
        <div class="field">
            <label for="certificationYear" class="font-semibold">
                Certification Year <span class="text-red-500">*</span>
            </label>
            <input
                pInputText
                id="certificationYear"
                type="number"
                formControlName="certificationYear"
                [min]="currentYear"
                placeholder="Enter certification year">
            @if (createReviewForm.get('certificationYear')?.invalid && createReviewForm.get('certificationYear')?.touched) {
                <small class="p-error">Certification year is required and must be current year or later</small>
            }
        </div>

        <div class="field">
            <label for="proposedExpiryDate" class="font-semibold">
                Proposed Expiry Date <span class="text-red-500">*</span>
            </label>
            <p-datepicker
                id="proposedExpiryDate"
                formControlName="proposedExpiryDate"
                [minDate]="minDate"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                placeholder="Select expiry date">
            </p-datepicker>
            @if (createReviewForm.get('proposedExpiryDate')?.invalid && createReviewForm.get('proposedExpiryDate')?.touched) {
                <small class="p-error">Proposed expiry date is required</small>
            }
        </div>

        <div class="field">
            <label for="notes" class="font-semibold">Notes</label>
            <textarea
                pTextarea
                id="notes"
                formControlName="notes"
                rows="3"
                placeholder="Optional notes about this review"
                class="w-full">
      </textarea>
        </div>
    </form>

    <ng-template #footer>
        <div class="flex justify-content-end gap-2">
            <p-button
                label="Cancel"
                severity="secondary"
                (onClick)="closeCreateDialog()">
            </p-button>
            <p-button
                label="Start"
                icon="pi pi-check"
                [disabled]="createReviewForm.invalid || licenseStore.activeReviewLoading()"
                [loading]="licenseStore.activeReviewLoading()"
                (onClick)="createReview()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>
